import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DataObjectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"data_object"}/>
}
